module.exports = __webpack_public_path__ + "img/cintillo_2027.9a55fcc5.png";